import React from "react";
import { Paper, Typography, Grid, IconButton, Tooltip } from "@mui/material";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../../common/CommonLoader";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";

const ViewWaterProfile = ({ profile }) => {
  if (!profile) {
    return null;
  }

  const formatNumber = (value) => 
    value !== null && value !== undefined ? value.toFixed(2) : "N/A";

  const chemicalProperties = [
    { label: "Calcium", value: formatNumber(profile.calcium), unit: "mg/L" },
    { label: "Total Alkalinity", value: formatNumber(profile.totalAlkalinity), unit: "mg/L" },
    { label: "Bicarbonate", value: formatNumber(profile.bicarbonate), unit: "mg/L" },
    { label: "Sulfate", value: formatNumber(profile.sulfate), unit: "mg/L" },
    { label: "Magnesium", value: formatNumber(profile.magnesium), unit: "mg/L" },
    { label: "Total Hardness", value: formatNumber(profile.totalHardness), unit: "mg/L" },
    { label: "Iron", value: formatNumber(profile.iron), unit: "mg/L" },
    { label: "pH", value: formatNumber(profile.pH), unit: "" },
    { label: "Total Chlorine", value: formatNumber(profile.totalChlorine), unit: "mg/L" },
    { label: "Residual Alkalinity", value: formatNumber(profile.residualAlkalinity), unit: "mg/L" },
    { label: "Chloride", value: formatNumber(profile.chloride), unit: "mg/L" },
    { label: "Sulfate to Chloride Ratio", value: formatNumber(profile.sulfateToChlorideRatio), unit: "" },
    { label: "Sodium", value: formatNumber(profile.sodium), unit: "mg/L" },
    { label: "Zinc", value: formatNumber(profile.zinc), unit: "mg/L" },
    { label: "Potassium", value: formatNumber(profile.potassium), unit: "mg/L" },
    { label: "Copper", value: formatNumber(profile.copper), unit: "mg/L" },
    { label: "TDS", value: formatNumber(profile.tds), unit: "mg/L" },
  ];

  return (
    <Paper elevation={3} style={{ padding: "16px", marginBottom: "20px" }}>
      <Typography variant="h6" gutterBottom>
        Water Profile Details
      </Typography>

      <Grid container spacing={2}>
        {/* Basic Information */}
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            <strong>Account Number:</strong> {profile.accountNumber || "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            <strong>Type:</strong> {profile.type || "N/A"}
          </Typography>
        </Grid>

        {/* Chemical Properties */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Chemical Properties
          </Typography>
        </Grid>
        
        {chemicalProperties.map((prop, index) => (
          <Grid item xs={6} sm={4} md={3} key={index}>
            <Typography variant="subtitle1">
              <strong>{prop.label}:</strong> {prop.value} {prop.unit}
            </Typography>
          </Grid>
        ))}

        {/* Audit Information */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Audit Information
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            <strong>Created At:</strong>{" "}
            {profile.createdAt ? new Date(profile.createdAt).toLocaleString() : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            <strong>Created By:</strong> {profile.createdBy || "N/A"}
          </Typography>
        </Grid>
        {profile.modifiedAt && (
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Modified At:</strong>{" "}
              {new Date(profile.modifiedAt).toLocaleString()}
            </Typography>
          </Grid>
        )}
        {profile.modifiedBy && (
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Modified By:</strong> {profile.modifiedBy}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default ViewWaterProfile;